import styled from 'styled-components';

export const TooltipContent = styled.div`
  padding: 10px;
  max-width: 300px;
  font-size: 0.9rem;
  line-height: 1.34;
`;
